// extracted by mini-css-extract-plugin
export var closeButton = "_kf-1";
export var closeX = "_kf-3";
export var container = "_kf-0";
export var image = "_kf-2";